/* NgRx */
import {createAction, props} from '@ngrx/store';
import {Filter} from "../../../../models/filter";
import {
  ParticipantUsernameFilter
} from "../models/participant-username-filter.model";
import {EmailPreviewDataModel} from "../models/email-preview-data.model";
import {HasAssociatedLarModel} from "../models/has-associated-lar.model";
import {GroupOptionsModel} from "../models/group-options.model";
import {ClientOptionsModel} from "../models/client-options.model";


/******** CLEAR STATE ***********/
const CLEAR_STATE = '[invite] clear state';
export const ClearState = createAction(CLEAR_STATE);

/******** FETCH GROUPS FILTER ***********/
const FETCH_GROUP_FILTER_REQUEST = '[invite] fetch group filter requested';
export const FetchGroupsFilterRequest = createAction(FETCH_GROUP_FILTER_REQUEST, props<{
  payload?: GroupOptionsModel['request']
}>());

const FETCH_GROUP_FILTER_SUCCESS = '[invite] fetch group filter successful';
export const FetchGroupFilterSuccess = createAction(FETCH_GROUP_FILTER_SUCCESS, props<{
  groupFilter: Filter,
  message: string
}>());

const FETCH_GROUP_FILTER_FAILURE = '[invite] fetch group filter failure';
export const FetchGroupFilterFailure = createAction(FETCH_GROUP_FILTER_FAILURE);

/******** FETCH CLIENT FILTER ***********/
const FETCH_CLIENT_FILTER_REQUEST = '[invite] fetch client filter requested';
export const FetchClientFilterRequest = createAction(FETCH_CLIENT_FILTER_REQUEST, props<{
  payload?: ClientOptionsModel['request']
}>());

const FETCH_CLIENT_FILTER_SUCCESS = '[invite] fetch client filter successful';
export const FetchClientFilterListSuccess = createAction(FETCH_CLIENT_FILTER_SUCCESS, props<{
  clientFilter: Filter,
  message: string
}>());

const FETCH_CLIENT_FILTER_FAILURE = '[invite] fetch client filter failure';
export const FetchClientFilterFailure = createAction(FETCH_CLIENT_FILTER_FAILURE);

/******** INVITE USER ***********/
const INVITE_USER_REQUEST = '[invite] invite user requested';
// THE KEY FOR REQUEST CHANGE DEPENDING ON THE ROLE HENCE KEPT THE TYPE FOR PROPS AS ANY //
export const InviteUserRequest = createAction(INVITE_USER_REQUEST, props<any>());

const INVITE_USER_SUCCESS = '[invite] invite user successful';
export const InviteUserSuccess = createAction(INVITE_USER_SUCCESS, props<{ message: string, data: any }>());

const INVITE_USER_FAILURE = '[invite] invite user failure';
export const InviteUserFailure = createAction(INVITE_USER_FAILURE);

/******** FETCH PARTICIPANT USERNAME FILTER ***********/

const FETCH_PARTICIPANT_USERNAME_FILTER_REQUEST = '[invite] fetch participant username filter requested';
export const FetchParticipantUsernameFilterRequest = createAction(FETCH_PARTICIPANT_USERNAME_FILTER_REQUEST, props<{
  payload: ParticipantUsernameFilter['request']
}>());
const FETCH_PARTICIPANT_USERNAME_FILTER_SUCCESS = '[invite] fetch participant username filter successful';
export const FetchParticipantUsernameFilterSuccess = createAction(FETCH_PARTICIPANT_USERNAME_FILTER_SUCCESS, props<{
  participantUsernameFilter: Filter,
  message: string
}>());
const FETCH_PARTICIPANT_USERNAME_FILTER_FAILURE = '[invite] fetch participant username filter failure';
export const FetchParticipantUsernameFilterFailure = createAction(FETCH_PARTICIPANT_USERNAME_FILTER_FAILURE);

/******** FETCH EMAIL PREVIEW DATA ***********/
const FETCH_EMAIL_PREVIEW_DATA_REQUEST = '[invite] fetch email preview data requested';
export const FetchEmailPreviewDataRequest = createAction(FETCH_EMAIL_PREVIEW_DATA_REQUEST, props<any>());


const FETCH_PREVIEW_INVITE_DATA_REQUEST = '[invite] fetch preview invite data requested';
export const FetchPreviewInviteDataRequest = createAction(FETCH_PREVIEW_INVITE_DATA_REQUEST, props<{userId: number}>());

const FETCH_EMAIL_PREVIEW_DATA_SUCCESS = '[invite] fetch email preview data successful';
export const FetchEmailPreviewDataSuccess = createAction(FETCH_EMAIL_PREVIEW_DATA_SUCCESS, props<{
  emailPreviewData: EmailPreviewDataModel[],
  message: string
}>());

const FETCH_EMAIL_PREVIEW_DATA_FAILURE = '[invite] fetch email preview data failure';
export const FetchEmailPreviewDataFailure = createAction(FETCH_EMAIL_PREVIEW_DATA_FAILURE);

/******** FETCH ADULT USERNAME FILTER ***********/

const FETCH_ADULT_USERNAME_FILTER_REQUEST = '[invite] fetch adult username filter requested';
export const FetchAdultUsernameFilterRequest = createAction(FETCH_ADULT_USERNAME_FILTER_REQUEST, props<{
  payload: ParticipantUsernameFilter['request']
}>());
const FETCH_ADULT_USERNAME_FILTER_SUCCESS = '[invite] fetch adult username filter successful';
export const FetchAdultUsernameFilterSuccess = createAction(FETCH_ADULT_USERNAME_FILTER_SUCCESS, props<{
  adultUsernameFilter: Filter,
  message: string
}>());
const FETCH_ADULT_USERNAME_FILTER_FAILURE = '[invite] fetch adult username filter failure';
export const FetchAdultUsernameFilterFailure = createAction(FETCH_ADULT_USERNAME_FILTER_FAILURE);

/******** HAS ASSOCIATED LAR ***********/

const HAS_ASSOCIATED_LAR_REQUEST = '[invite] has associated lar requested';
export const HasAssociatedLarRequest = createAction(HAS_ASSOCIATED_LAR_REQUEST, props<{
  payload: HasAssociatedLarModel['request']
}>());
const HAS_ASSOCIATED_LAR_SUCCESS = '[invite] has associated lar successful';
export const HasAssociatedLarSuccess = createAction(HAS_ASSOCIATED_LAR_SUCCESS, props<{
  hasAssociatedLar: boolean,
  message: string
}>());
const HAS_ASSOCIATED_LAR_FAILURE = '[invite] has associated lar failure';
export const HasAssociatedLarFailure = createAction(HAS_ASSOCIATED_LAR_FAILURE);

/******** CLEAR PARTICIPANT USERNAME FILTER ***********/

const CLEAR_PARTICIPANT_USERNAME_FILTER = '[invite] clear participant username filter';
export const ClearParticipantUsernameFilter = createAction(CLEAR_PARTICIPANT_USERNAME_FILTER);

/******** CLEAR ADULT USERNAME FILTER ***********/

const CLEAR_ADULT_USERNAME_FILTER = '[invite] clear adult username filter';
export const ClearAdultUsernameFilter = createAction(CLEAR_ADULT_USERNAME_FILTER);

/******** CLEAR CLIENT FILTER ***********/

const CLEAR_CLIENT_FILTER = '[invite] clear client filter';
export const ClearClientFilter = createAction(CLEAR_CLIENT_FILTER);

/******** FETCH ADULT USERNAME FILTER ***********/

const RELEASE_USERNAME_REQUEST = '[invite] release username requested';
export const ReleaseUsernameRequest = createAction(RELEASE_USERNAME_REQUEST, props<{
  payload: { uuid: string }
}>());
const RELEASE_USERNAME_SUCCESS = '[invite] release username successful';
export const ReleaseUsernameSuccess = createAction(RELEASE_USERNAME_SUCCESS);

const RELEASE_USERNAME_FAILURE = '[invite] release username failure';
export const ReleaseUsernameFailure = createAction(RELEASE_USERNAME_FAILURE);

/******** SET EMAIL PREVIEW DATA ***********/

const SET_EMAIL_PREVIEW_DATA = '[invite] set email preview data';
export const SetEmailPreviewData = createAction(SET_EMAIL_PREVIEW_DATA, props<{
  emailPreviewData: EmailPreviewDataModel[]
}>());
